<template>
    <aside 
        class="tw:w-auto tw:max-w-80 tw:bg-white tw:rounded-lg tw:shadow-lg tw:p-4 tw:h-fit tw:z-0"
        role="navigation"
        :aria-label="$t('perfil.nav_aria_label')"
    >
        <nav class="tw:flex tw:flex-col tw:gap-2 ">
            <button
                v-for="tab in tabs"
                :key="tab.id"
                :data-testid="`sidebar-${tab.id}`"
                class="tw:w-full tw:px-4 tw:py-3 tw:rounded-lg tw:font-medium tw:transition-all tw:duration-100 tw:flex tw:items-center tw:gap-3"
                :class="getButtonClass(tab.id)"
                :aria-current="isActive(tab.id) ? 'page' : null"
                @click="handleTabChange(tab.id)"
            >
                <span class="tw:lg:text-base tw:whitespace-nowrap tw:capitalize">{{ tab.label }}</span>
            </button>
        </nav>
    </aside>
</template>

<script setup>
    const props = defineProps({
        tabs: { type: Array, required: true },
        activeTab: { type: String, required: true }
    });
    
    const emit = defineEmits(['change-tab']);
    
    const isActive = tabId => props.activeTab === tabId;
    const handleTabChange = tabId => emit('change-tab', tabId);
    
    const getButtonClass = tabId => {
        return isActive(tabId) ? 'altcolor-content tw:shadow-lg' : 'tw:hover:ring-1 tw:hover:ring-[var(--altcolor)] tw:hover:text-[var(--altcolor)]';
    };
</script>
